import { render, staticRenderFns } from "./Laboratory.vue?vue&type=template&id=10476fb3&"
import script from "./Laboratory.vue?vue&type=script&lang=js&"
export * from "./Laboratory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports